import { render, staticRenderFns } from "./userSettingsGeneral.vue?vue&type=template&id=b3599904&"
import script from "./userSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./userSettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports